import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a GA4 page_view event on every client-side route change.
 * The base gtag config in index.html only auto-fires on the initial
 * hard page load, so SPA navigations need to be tracked manually.
 */
export default function RouteChangeTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
}
